/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EmailAddress } from "./EmailAddress";
import {
  EmailAddressFromJSON,
  EmailAddressFromJSONTyped,
  EmailAddressToJSON,
  EmailAddressToJSONTyped,
} from "./EmailAddress";

/**
 * Augment UserSerializer with role information.
 * @export
 * @interface OrganisationUser
 */
export interface OrganisationUser {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  firstName?: string;
  /**
   *
   */
  lastName?: string;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   */
  username: string;
  /**
   *
   */
  email?: EmailAddress;
  /**
   * Return a list of roles of the given user in this organisation.
   */
  readonly roles?: Array<string>;
}

/**
 * Check if a given object implements the OrganisationUser interface.
 */
export function instanceOfOrganisationUser(value: object): value is OrganisationUser {
  if (!("username" in value) || value["username"] === undefined) return false;
  return true;
}

export function OrganisationUserFromJSON(json: any): OrganisationUser {
  return OrganisationUserFromJSONTyped(json, false);
}

export function OrganisationUserFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganisationUser {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    firstName: json["first_name"] == null ? undefined : json["first_name"],
    lastName: json["last_name"] == null ? undefined : json["last_name"],
    username: json["username"],
    email: json["email"] == null ? undefined : EmailAddressFromJSON(json["email"]),
    roles: json["roles"] == null ? undefined : json["roles"],
  };
}

export function OrganisationUserToJSON(json: any): OrganisationUser {
  return OrganisationUserToJSONTyped(json, false);
}

export function OrganisationUserToJSONTyped(
  value?: Omit<OrganisationUser, "id" | "roles"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    first_name: value["firstName"],
    last_name: value["lastName"],
    username: value["username"],
    email: EmailAddressToJSON(value["email"]),
  };
}
